import type { DuplicateRequestResponse } from "@nlc/shared-types";
import type { DefaultValues, UseFormReset } from "react-hook-form";

import type { CreateWebsiteImplementationRequestFormData } from "../components/useCreateWebsiteImplementationRequestForm";

import {
  mapAttachmentsByCategory,
  useDuplicateRequest,
} from "../../shared/useDuplicateRequest";

function mapDuplicateResponseToFormData(
  data: DuplicateRequestResponse,
): DefaultValues<CreateWebsiteImplementationRequestFormData> {
  return {
    assets: mapAttachmentsByCategory(data.attachments, "asset"),
    brandId: data.brandId || undefined,
    collaboratorIds: data.collaboratorIds || [],
    designComplexityId: data.complexityId || undefined,
    designTypeId: data.designTypeId ?? undefined,
    inspirations: mapAttachmentsByCategory(data.attachments, "example"),
    preferredDesignerIds: data.preferredDesignerIds || [],
    requestDescription: data.description || "",
    requestDescriptionHTML: data.description || "",
    requestName: data.name || "",
  };
}

interface UseDuplicateWebsiteImplementationRequestProps {
  reset: UseFormReset<CreateWebsiteImplementationRequestFormData>;
}

export function useDuplicateWebsiteImplementationRequest({
  reset,
}: UseDuplicateWebsiteImplementationRequestProps) {
  return useDuplicateRequest<CreateWebsiteImplementationRequestFormData>({
    mapDuplicateResponseToFormData,
    reset,
  });
}
